<template>
    <div class="content-wrapper">
        <div class="content-header">
            <div
                class="d-flex align-items-center"
                style="
                    border-bottom: 1px solid #5c4a4a17;
                    margin: auto !important;
                "
            >
                <div class="row">
                    <div
                        class="col-sm-6 d-flex flex-column align-items-baseline"
                    >
                        <h1 class="m-0 text-dark">Website Dashboard</h1>
                        <ol class="breadcrumb float-sm-left">
                            <router-link
                                tag="li"
                                class="breadcrumb-item"
                                :to="{ name: 'Home' }"
                                >Home</router-link
                            >
                            <router-link
                                tag="li"
                                class="breadcrumb-item"
                                :to="{ name: 'Dashboard' }"
                                >Dashboard</router-link
                            >
                            <li class="breadcrumb-item active">
                                Website Dashboard:
                            </li>
                            <span class="ml-2">{{
                                getDomainUrl($route.params.id)
                            }}</span>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
        <section class="content mt-3">
            <div
                class="container"
                style="margin: auto !important; overflow: hidden"
            >
                <div class="row">
                    <div
                        class="col-md-12 border"
                        style="padding: 0 !important; margin: 0 0 21px 0"
                    >
                        <div
                            class="d-flex justify-content-between btns-info-h border-bottom"
                            v-if="!isUserRole"
                        >
                            <span>THINGS&nbsp;TO&nbsp;DO</span>
                            <em
                                class="bi-x-lg mr-2 d-flex align-items-center"
                                style="font-size: 11px"
                                @click="shwThingsToDo = !shwThingsToDo"
                            ></em>
                        </div>
                        <div v-show="shwThingsToDo && !isUserRole">
                            <div class="box bg-2" style="visibility: visible">
                                <div>
                                    <router-link
                                        tag="button"
                                        :to="{ name: 'MainDash' }"
                                        class="button button--sacnite button--round-l"
                                    >
                                        <em class="bi bi-person-plus"></em>
                                    </router-link>
                                    <h4>Welcome Drip</h4>
                                    <h5>
                                        Click here to enable and edit welcome
                                        drip notification.
                                    </h5>
                                </div>
                                <div @click="changeDmnStatus">
                                    <button
                                        class="button button--sacnite button--round-l"
                                    >
                                        <em
                                            class="bi"
                                            :class="{
                                                'bi-toggle-on': dmnStatus,
                                                'bi-toggle-off': !dmnStatus,
                                            }"
                                        ></em>
                                    </button>
                                    <h4>
                                        Status is:
                                        {{ dmnStatus ? "on" : "off" }}
                                    </h4>
                                    <h5>Change your domain status.</h5>
                                </div>
                                <!-- <div v-if="acceptedRole || writePermission">
                  <button
                    class="button button--sacnite button--round-l"
                    @click="shwConnectPopUp = !shwConnectPopUp"
                  >
                    <em class="bi bi-gear"></em>
                  </button>
                  <h4>Connections</h4>
                  <h5>Click here to configure the connections.</h5>
                </div> -->
                                <!-- <div>
                  <button
                    class="button button--sacnite button--round-l"
                    @click="shwChangeDmnName = !shwChangeDmnName"
                  >
                    <em class="bi bi-pencil-square"></em>
                  </button>
                  <h4>Domain Name</h4>
                  <h5>Click here to change your domain name.</h5>
                </div> -->
                                <div v-show="shwThingsToDo && !isUserRole">
                                    <div
                                        class="box bg-2 pt-0"
                                        style="visibility: visible"
                                    >
                                        <div @click="showPostbackPopUp = true">
                                            <button
                                                class="button button--sacnite button--round-l"
                                            >
                                                <em
                                                    class="bi bi-link-45deg"
                                                ></em>
                                            </button>
                                            <h4>Postback</h4>
                                        </div>
                                        <div style="height: 100px"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="row d-flex flex-row justify-content-evenly mb-6"
                    v-if="isStatsVisible"
                >
                    <div
                        class="col-md-3"
                        :class="{
                            'height-140':
                                roles.includes('admin_demo') || isUserRole,
                        }"
                    >
                        <span>
                            <svg
                                width="18"
                                height="17"
                                viewBox="0 0 18 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M5.31667 1.90004L4.125 0.708374C2.125 2.23337 0.808332 4.58337 0.691666 7.25004H2.35833C2.48333 5.04171 3.61667 3.10837 5.31667 1.90004ZM15.6417 7.25004H17.3083C17.1833 4.58337 15.8667 2.23337 13.875 0.708374L12.6917 1.90004C14.375 3.10837 15.5167 5.04171 15.6417 7.25004ZM14 7.66671C14 5.10837 12.6333 2.96671 10.25 2.40004V1.83337C10.25 1.14171 9.69167 0.583374 9 0.583374C8.30833 0.583374 7.75 1.14171 7.75 1.83337V2.40004C5.35833 2.96671 4 5.10004 4 7.66671V11.8334L2.33333 13.5V14.3334H15.6667V13.5L14 11.8334V7.66671ZM9 16.8334C9.11667 16.8334 9.225 16.825 9.33333 16.8C9.875 16.6834 10.3167 16.3167 10.5333 15.8167C10.6167 15.6167 10.6583 15.4 10.6583 15.1667H7.325C7.33333 16.0834 8.075 16.8334 9 16.8334Z"
                                    fill="#3171B3"
                                />
                            </svg>
                            Recurring Drips
                        </span>
                        <v-divider class="m-1"></v-divider>
                        <div class="d-flex flex-row">
                            <div
                                class="d-flex flex-column mt-4"
                                style="width: 50px !important"
                            >
                                <p class="text-left m-1 p-0 font-size-11">
                                    Sent
                                </p>
                                <p class="text-left m-1 p-0 font-size-11">
                                    Clicks
                                </p>
                                <p class="text-left m-1 p-0 font-size-11">
                                    Deliveries
                                </p>
                            </div>
                            <v-divider
                                vertical
                                class="m-1"
                                style="height: 80px"
                            ></v-divider>
                            <div class="d-flex justify-content-around">
                                <div class="m-0">
                                    <p
                                        class="m-1 mt-0 p-0 ml-5 mr-7 font-size-11"
                                        style="margin-bottom: 2px !important"
                                    >
                                        Totals
                                    </p>
                                    <!-- Recurring Totals Sends -->
                                    <div
                                        class="mt-1 ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p class="m-0 p-0" v-if="!indexLoader">
                                            {{
                                                formatNumber(
                                                    recurring.sends.totals
                                                )
                                            }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                    <!-- Recurring Totals Clicks -->
                                    <div
                                        class="mt-1 ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p class="m-0 p-0" v-if="!indexLoader">
                                            {{
                                                formatNumber(
                                                    recurring.clicks.totals
                                                )
                                            }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                    <!-- Recurring Totals Deliveries -->
                                    <div
                                        class="mt-1 m-0 ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p class="m-0 p-0" v-if="!indexLoader">
                                            {{
                                                formatNumber(
                                                    recurring.deliveries.totals
                                                )
                                            }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                </div>
                                <div class="m-0 ml-1">
                                    <p
                                        class="mt-0 mb-0 p-0 font-size-11"
                                        style="margin-bottom: 2px !important"
                                    >
                                        This week
                                    </p>
                                    <!-- Recurring This Week Sends -->
                                    <div
                                        class="mt-1 m-0 mb-1 ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p class="m-0 p-0" v-if="!indexLoader">
                                            {{
                                                formatNumber(
                                                    recurring.sends.thisWeek
                                                )
                                            }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                    <!-- Recurring This Week Clicks -->
                                    <div
                                        class="mt-1 ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p class="m-0 p-0" v-if="!indexLoader">
                                            {{
                                                formatNumber(
                                                    recurring.clicks.thisWeek
                                                )
                                            }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                    <!-- Recurring This Week Deliveries -->
                                    <div
                                        class="mt-1 ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p class="m-0 p-0" v-if="!indexLoader">
                                            {{
                                                formatNumber(
                                                    recurring.deliveries
                                                        .thisWeek
                                                )
                                            }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <router-link
                            v-if="isMoreInfoVisible"
                            tag="span"
                            :to="{ name: 'More Info' }"
                            class="more-info-block cursor-pointer"
                        >
                            More info
                            <svg
                                width="7"
                                height="11"
                                viewBox="0 0 7 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M0.15834 1.86883L3.97501 5.75008L0.15834 9.63133L1.33334 10.8236L6.33334 5.75008L1.33334 0.67655L0.15834 1.86883Z"
                                    fill="#272727"
                                />
                            </svg>
                        </router-link>
                    </div>
                    <div
                        class="col-md-3"
                        :class="{
                            'height-140':
                                roles.includes('admin_demo') || isUserRole,
                        }"
                    >
                        <span>
                            <svg
                                width="18"
                                height="17"
                                viewBox="0 0 18 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M5.31667 1.90004L4.125 0.708374C2.125 2.23337 0.808332 4.58337 0.691666 7.25004H2.35833C2.48333 5.04171 3.61667 3.10837 5.31667 1.90004ZM15.6417 7.25004H17.3083C17.1833 4.58337 15.8667 2.23337 13.875 0.708374L12.6917 1.90004C14.375 3.10837 15.5167 5.04171 15.6417 7.25004ZM14 7.66671C14 5.10837 12.6333 2.96671 10.25 2.40004V1.83337C10.25 1.14171 9.69167 0.583374 9 0.583374C8.30833 0.583374 7.75 1.14171 7.75 1.83337V2.40004C5.35833 2.96671 4 5.10004 4 7.66671V11.8334L2.33333 13.5V14.3334H15.6667V13.5L14 11.8334V7.66671ZM9 16.8334C9.11667 16.8334 9.225 16.825 9.33333 16.8C9.875 16.6834 10.3167 16.3167 10.5333 15.8167C10.6167 15.6167 10.6583 15.4 10.6583 15.1667H7.325C7.33333 16.0834 8.075 16.8334 9 16.8334Z"
                                    fill="#3171B3"
                                />
                            </svg>
                            Welcome Drips
                        </span>
                        <v-divider class="m-1"></v-divider>
                        <div class="d-flex flex-row">
                            <div
                                class="d-flex flex-column mt-4"
                                style="width: 50px !important"
                            >
                                <p class="text-left m-1 p-0 font-size-11">
                                    Sent
                                </p>
                                <p class="text-left m-1 p-0 font-size-11">
                                    Clicks
                                </p>
                                <p class="text-left m-1 p-0 font-size-11">
                                    Deliveries
                                </p>
                            </div>
                            <v-divider
                                vertical
                                class="m-1"
                                style="height: 80px"
                            ></v-divider>
                            <div class="d-flex justify-content-around">
                                <div class="m-0">
                                    <p
                                        class="m-0 p-0 ml-5 mr-7 font-size-11"
                                        style="margin-bottom: 2px !important"
                                    >
                                        Totals
                                    </p>
                                    <!-- Welcome Totals Sends -->
                                    <div
                                        class="mt-1 ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p class="m-0 p-0" v-if="!indexLoader">
                                            {{
                                                formatNumber(
                                                    welcome.sends.totals
                                                )
                                            }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                    <!-- Welcome Totals Clicks -->
                                    <div
                                        class="mt-1 ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p class="m-0 p-0" v-if="!indexLoader">
                                            {{
                                                formatNumber(
                                                    welcome.clicks.totals
                                                )
                                            }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                    <!-- Welcome Totals Deliveries -->
                                    <div
                                        class="mt-1 ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p class="m-0 p-0" v-if="!indexLoader">
                                            {{
                                                formatNumber(
                                                    welcome.deliveries.totals
                                                )
                                            }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                </div>
                                <div class="m-0">
                                    <p
                                        class="m-0 p-0 font-size-11"
                                        style="margin-bottom: 2px !important"
                                    >
                                        This week
                                    </p>
                                    <!-- Welcome This Week Sends -->
                                    <div
                                        class="mt-1 ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p class="m-0 p-0" v-if="!indexLoader">
                                            {{
                                                formatNumber(
                                                    welcome.sends.thisWeek
                                                )
                                            }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                    <!-- Welcome This Week Clicks -->
                                    <div
                                        class="mt-1 ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p class="m-0 p-0" v-if="!indexLoader">
                                            {{
                                                formatNumber(
                                                    welcome.clicks.thisWeek
                                                )
                                            }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                    <!-- Welcome This Week Deliveries -->
                                    <div
                                        class="mt-1 ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p class="m-0 p-0" v-if="!indexLoader">
                                            {{
                                                formatNumber(
                                                    welcome.deliveries.thisWeek
                                                )
                                            }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <router-link
                            v-if="isMoreInfoVisible"
                            tag="span"
                            :to="{ name: 'More Info' }"
                            class="more-info-block cursor-pointer"
                        >
                            More info
                            <svg
                                width="7"
                                height="11"
                                viewBox="0 0 7 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M0.15834 1.86883L3.97501 5.75008L0.15834 9.63133L1.33334 10.8236L6.33334 5.75008L1.33334 0.67655L0.15834 1.86883Z"
                                    fill="#272727"
                                />
                            </svg>
                        </router-link>
                    </div>
                    <div
                        class="col-md-3"
                        :class="{
                            'height-140':
                                roles.includes('admin_demo') || isUserRole,
                        }"
                    >
                        <span>
                            <svg
                                width="20"
                                height="11"
                                viewBox="0 0 20 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M10 6.125C11.3583 6.125 12.5583 6.45 13.5333 6.875C14.4333 7.275 15 8.175 15 9.15V10.5H5V9.15833C5 8.175 5.56667 7.275 6.46667 6.88333C7.44167 6.45 8.64167 6.125 10 6.125ZM3.33333 6.33333C4.25 6.33333 5 5.58333 5 4.66667C5 3.75 4.25 3 3.33333 3C2.41667 3 1.66667 3.75 1.66667 4.66667C1.66667 5.58333 2.41667 6.33333 3.33333 6.33333ZM4.275 7.25C3.96667 7.2 3.65833 7.16667 3.33333 7.16667C2.50833 7.16667 1.725 7.34167 1.01667 7.65C0.4 7.91667 0 8.51667 0 9.19167V10.5H3.75V9.15833C3.75 8.46667 3.94167 7.81667 4.275 7.25ZM16.6667 6.33333C17.5833 6.33333 18.3333 5.58333 18.3333 4.66667C18.3333 3.75 17.5833 3 16.6667 3C15.75 3 15 3.75 15 4.66667C15 5.58333 15.75 6.33333 16.6667 6.33333ZM20 9.19167C20 8.51667 19.6 7.91667 18.9833 7.65C18.275 7.34167 17.4917 7.16667 16.6667 7.16667C16.3417 7.16667 16.0333 7.2 15.725 7.25C16.0583 7.81667 16.25 8.46667 16.25 9.15833V10.5H20V9.19167ZM10 0.5C11.3833 0.5 12.5 1.61667 12.5 3C12.5 4.38333 11.3833 5.5 10 5.5C8.61667 5.5 7.5 4.38333 7.5 3C7.5 1.61667 8.61667 0.5 10 0.5Z"
                                    fill="#3171B3"
                                />
                            </svg>
                            Subscribers
                        </span>
                        <v-divider class="m-1"></v-divider>
                        <div class="d-flex flex-row justify-content-center">
                            <div class="d-flex">
                                <div class="m-0">
                                    <p
                                        class="m-0 p-0 ml-5 mr-7 font-size-11"
                                        style="margin-bottom: 2px !important"
                                    >
                                        Totals
                                    </p>
                                    <div
                                        class="ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p class="m-0 p-0" v-if="!indexLoader">
                                            {{ formatNumber(subs.subs.totals) }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                </div>
                                <div class="m-0">
                                    <p
                                        class="m-0 p-0 font-size-11"
                                        style="margin-bottom: 2px !important"
                                    >
                                        This week
                                    </p>
                                    <div
                                        class="ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p class="m-0 p-0" v-if="!indexLoader">
                                            {{
                                                formatNumber(subs.subs.thisWeek)
                                            }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                </div>
                                <div class="m-0">
                                    <p
                                        class="m-0 p-0 font-size-11"
                                        style="margin-bottom: 2px !important"
                                    >
                                        This month
                                    </p>
                                    <div
                                        class="ml-1 p-0 font-weight-bold index-overflow index-block"
                                    >
                                        <p class="m-0 p-0" v-if="!indexLoader">
                                            {{
                                                formatNumber(
                                                    subs.subs.thisMonth
                                                )
                                            }}
                                        </p>
                                        <Spinner
                                            v-else
                                            class="spinner-loading--sm"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <router-link
                            v-if="isMoreInfoVisible"
                            tag="span"
                            :to="{ name: 'More Info' }"
                            class="more-info-block cursor-pointer"
                        >
                            More info
                            <svg
                                width="7"
                                height="11"
                                viewBox="0 0 7 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M0.15834 1.86883L3.97501 5.75008L0.15834 9.63133L1.33334 10.8236L6.33334 5.75008L1.33334 0.67655L0.15834 1.86883Z"
                                    fill="#272727"
                                />
                            </svg>
                        </router-link>
                    </div>
                </div>
                <div class="row border" v-if="isStatsVisible">
                    <span
                        class="d-flex align-items-center border-bottom p-2"
                        style="font-size: 11px"
                        >SUMARRY ANALITICS</span
                    >
                    <div
                        class="d-flex justify-content-between"
                        style="height: 114px"
                    >
                        <div
                            class="d-flex flex-column"
                            style="
                                margin-top: 15px;
                                height: 34px;
                                position: relative;
                            "
                        >
                            <!-- Calendar -->
                            <v-menu
                                ref="menu"
                                v-model="menu"
                                :close-on-content-click="false"
                                :return-value="datePicker"
                                :max="maxDate"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                                style="max-height: 400px !important"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="datePickerRangeText"
                                        prepend-inner-icon="mdi-calendar"
                                        readonly
                                        outlined
                                        dense
                                        full-width
                                        v-bind="attrs"
                                        v-on="on"
                                        :disabled="chartLoader || fileLoading"
                                        :loading="chartLoader || fileLoading"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="datePicker"
                                    range
                                    no-title
                                    scrollable
                                    :min="minDate"
                                    :max="maxDate"
                                    :disabled="chartLoader || fileLoading"
                                    :loading="chartLoader || fileLoading"
                                >
                                </v-date-picker>
                            </v-menu>
                            <!-- <date-picker
                v-model="datePicker"
                style="width: 200px !important"
                type="date"
                range
                placeholder="Select date"
                :disabled="chartLoader || fileLoading"
              ></date-picker> -->
                            <div
                                class="d-flex align-items-center"
                                style="margin: -7px 40px 0px 0px"
                            >
                                <v-autocomplete
                                    id="timezones"
                                    auto-select-first
                                    dense
                                    outlined
                                    v-model="selectedTimezone"
                                    style="width: 200px !important"
                                    :items="timezones"
                                    :disabled="chartLoader || fileLoading"
                                    :loading="chartLoader || fileLoading"
                                ></v-autocomplete>
                            </div>
                            <div
                                class="d-flex align-items-center"
                                v-if="!chartLoader && !fileLoading"
                            >
                                <v-tooltip right>
                                    <template v-slot:activator="{ on, attrs }">
                                        <div
                                            class="d-flex align-items-center ml-1 mt-1"
                                            style="
                                                cursor: pointer;
                                                position: absolute;
                                                top: 0;
                                                right: -20px;
                                            "
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="refreshChart"
                                        >
                                            <em
                                                class="bi-arrow-clockwise"
                                                style="color: #0073b7"
                                                v-if="!refreshModeStatus"
                                            ></em>
                                            <div
                                                class="spinner-border text-primary"
                                                style="
                                                    font-size: 5px;
                                                    width: 12px;
                                                    height: 12px;
                                                "
                                                role="status"
                                                v-else
                                            >
                                                <span class="sr-only"
                                                    >Loading...</span
                                                >
                                            </div>
                                        </div>
                                    </template>
                                    <span
                                        >resets to the default chart
                                        settings</span
                                    >
                                </v-tooltip>
                            </div>
                        </div>
                        <div class="d-flex mt-2">
                            <!-- <div
                class="d-flex align-items-start"
                style="margin: 8px 12px 0 0"
                v-if="!isUserRole"
              >
                <select
                  ref="groupBySelect"
                  name="groupBySelect"
                  id="groupBySelectValue"
                  v-model="groupBySelectValue"
                  class="d-none"
                  style="padding: 7px; height: 33px"
                  :disabled="chartLoader || fileLoading"
                >
                  <option value="select">Group By:</option>
                  <option value="default">Default</option>
                  <option value="drip_id">Drip Id</option>
                </select>
              </div> -->
                            <!-- <div
                class="d-flex align-items-start"
                style="margin: 8px 12px 0 0"
              >
                <v-btn
                  style="font-size: 8px"
                  color="#9e9e9e75"
                  outlined
                  @click="downloadFile"
                  :disabled="fileInProgress"
                  :loading="chartLoader || fileLoading || fileInProgress"
                  height="33px"
                >
                  <template #default>
                    <span class="stats--button"> Export As CSV </span>
                  </template>
                </v-btn>
                <select
                  name="exportAsFormat"
                  id="exportAsFormat"
                  v-model="exportFormat"
                  style="padding: 7px; height: 33px"
                  :disabled="chartLoader || fileLoading"
                >
                  <option value="select">Export data as:</option>
                  <option value="json">JSON</option>
                  <option value="xlsx">XLSX</option>
                  <option value="csv">CSV</option>
                </select>
              </div> -->
                            <div class="btn-group mt-2 w-unset">
                                <v-btn
                                    class="font-size-10 text-transform-initial mr-1"
                                    small
                                    height="32"
                                    :text="btnClickedTitle !== 'hour'"
                                    :outlined="btnClickedTitle !== 'hour'"
                                    :color="
                                        btnClickedTitle === 'hour'
                                            ? 'primary'
                                            : ''
                                    "
                                    :loading="chartLoader || fileLoading"
                                    @click="btnClickedTitle = 'hour'"
                                >
                                    Hour
                                </v-btn>
                                <v-btn
                                    class="font-size-10 text-transform-initial mr-1"
                                    small
                                    height="32"
                                    :text="btnClickedTitle !== 'day'"
                                    :outlined="btnClickedTitle !== 'day'"
                                    :color="
                                        btnClickedTitle === 'day'
                                            ? 'primary'
                                            : ''
                                    "
                                    :loading="chartLoader || fileLoading"
                                    @click="btnClickedTitle = 'day'"
                                >
                                    Day
                                </v-btn>
                                <v-btn
                                    class="font-size-10 text-transform-initial"
                                    small
                                    height="32"
                                    :text="btnClickedTitle !== 'week'"
                                    :outlined="btnClickedTitle !== 'week'"
                                    :color="
                                        btnClickedTitle === 'week'
                                            ? 'primary'
                                            : ''
                                    "
                                    :loading="chartLoader || fileLoading"
                                    @click="btnClickedTitle = 'week'"
                                >
                                    Week
                                </v-btn>
                                <v-btn
                                    class="font-size-10 text-transform-initial"
                                    small
                                    height="32"
                                    :text="btnClickedTitle !== 'month'"
                                    :outlined="btnClickedTitle !== 'month'"
                                    :color="
                                        btnClickedTitle === 'month'
                                            ? 'primary'
                                            : ''
                                    "
                                    :loading="chartLoader || fileLoading"
                                    @click="btnClickedTitle = 'month'"
                                >
                                    Month
                                </v-btn>
                            </div>
                        </div>
                    </div>
                    <div class="py-4 position-relative" style="height: 500px">
                        <div
                            v-if="chartLoader || fileLoading"
                            class="spinner-border text-primary position-absolute"
                            role="status"
                            style="top: 45%; z-index: 99999"
                        >
                            <span class="sr-only">Loading...</span>
                        </div>
                        <ApexChart
                            ref="apexChart"
                            initialDataVariant="All Drips"
                            @update-data-variant="handleDataVariantUpdated"
                            :fileLoading="fileLoading || chartLoader"
                            :dataVariants="dataVariants"
                            :dateTrunc="btnClickedTitle"
                            :datasets="{
                                deliveries: deliveriesSeries,
                                clicks: clicksSeries,
                                totals: totalsSeries,
                                sends: sendsSeries,
                                subs: subsSeries,
                            }"
                        />
                    </div>
                </div>
            </div>
            <transition
                enter-active-class="animate__animated animate__fadeIn animate__faster"
                leave-active-class="animate__animated  animate__fadeOut animate__faster"
            >
                <Error v-if="error" error="error" />
            </transition>
            <transition
                enter-active-class="animate__animated animate__fadeIn animate__faster"
                leave-active-class="animate__animated  animate__fadeOut animate__faster"
            >
                <FailureSnackbar
                    v-if="failure"
                    @update-failure="handleUpdateToFailureSnackbar"
                    :message="failureMessage"
                />
            </transition>
            <transition
                class="animate__faster"
                enter-active-class="animate__animated animate__fadeIn animate__faster"
                leave-active-class="animate__animated animate__fadeOut animate__faster"
            >
                <SuccessSnackbar
                    v-if="success"
                    @update-success="handleUpdateToSuccessSnackbar"
                    :message="successMessage"
                />
            </transition>
            <transition
                enter-active-class="animate__animated animate__fadeIn animate__faster"
                leave-active-class="animate__animated  animate__fadeOut animate__faster"
            >
                <ConnectionSettings
                    v-if="shwConnectPopUp"
                    :url="selectedDomainWebsite($route.params.id).url"
                    :dmn_id="$route.params.id"
                />
            </transition>
            <transition
                enter-active-class="animate__animated animate__fadeIn animate__faster"
                leave-active-class="animate__animated  animate__fadeOut animate__faster"
            >
                <ChangeDmnName
                    v-if="shwChangeDmnName"
                    :url="
                        selectedDomainWebsite($route.params.id).url.split(
                            'https://'
                        )[1]
                    "
                />
            </transition>

            <!-- SnackBar -->
            <v-snackbar v-model="snackbar" color="#28a745" timeout="1000">
                Copied Successfully!
                <template v-slot:action="{ attrs }">
                    <v-btn
                        color="white"
                        text
                        v-bind="attrs"
                        @click="snackbar = false"
                    >
                        Close
                    </v-btn>
                </template>
            </v-snackbar>

            <transition
                enter-active-class="animate__animated animate__fadeIn animate__faster"
                leave-active-class="animate__animated  animate__fadeOut animate__faster"
            >
                <Files v-if="shwFilePopUp" @didClose="shwFilePopUp = false" />
            </transition>
            <!-- <SuccessSnackbar :snackbar="snackbar" message="Copied Successfully!" /> -->
        </section>
        <pre style="display: none">
            &lt;!-- Pushmine -->
            &lt;script src="pushmine.js" defer>&lt;/script>
            &lt;script>
              $(document).ready(function () { 
                new Worker("sw_pm.js");
                
                function allow() { 
                  // Your Code ...
                }
  
                function block() {
                  // Your Code ...
                }
  
                var pushminefc = {
                  onSuccess: allow,
                  onFailure: block,
                };
  
                if (Notification.permission !== "granted") {
                  initSW(pushminefc);
                }
              });
            &lt;/script>
            &lt;!-- Pushmine -->
      </pre
        >
        <v-dialog v-model="showPostbackPopUp" max-width="500px">
            <v-card style="margin: 0 !important">
                <v-card-title>Postback </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model="postbackUrl"
                        :loading="loading"
                        :disabled="loading"
                        outlined
                        label="Type your postback link here..."
                    ></v-text-field>
                </v-card-text>
                <v-card-actions class="d-flex justify-content-end">
                    <v-btn
                        color="primary"
                        text
                        :loading="loading"
                        :disabled="loading"
                        @click="
                            showPostbackPopUp = false;
                            postbackUrl = domain.postback;
                        "
                    >
                        Close
                    </v-btn>
                    <v-btn
                        color="primary"
                        outlined
                        text
                        :loading="loading"
                        :disabled="loading"
                        @click="addPostback"
                    >
                        Add
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import ChangeDmnName from "../popUps/domains/ChangeDmnName.vue";
import ConnectionSettings from "../popUps/connections/ConnectionSettings.vue";
//import ChartLine from "../../charts/ChartLine.js";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Domains from "../../apis/Domains";
// import "chartjs-adapter-moment";
import moment from "moment";
import FailureSnackbar from "../popUps/FailureSnackbar.vue";
import Error from "../popUps/Error.vue";
// import User from "../../apis/User";
import Statistics from "../../apis/Statistics.js";
import SuccessSnackbar from "../popUps/SuccessSnackbar.vue";
import Files from "../popUps/Files.vue";
//import Amplitude from "../../apis/Amplitude.js";
import { mapGetters, mapState, mapActions } from "vuex";
// import * as XLSX from "xlsx-js-style";
// import { saveAs } from "file-saver";

import ApexChart from "../../charts/ApexChart.vue";
import Spinner from "../popUps/Spinner.vue";

import statistics from "../../mixins/statistics";
import common from "../../mixins/common";

const momentTimezone = require("moment-timezone");
// import GroupChart from "../../charts/GroupChart.vue";

export default {
    name: "MainCont",
    components: {
        //ChartLine,
        DatePicker,
        ConnectionSettings,
        ChangeDmnName,
        SuccessSnackbar,
        Files,
        // GroupChart,
        ApexChart,
        Spinner,
        Error,
        FailureSnackbar,
    },
    mixins: [statistics, common],
    data() {
        return {
            dataVariants: [
                "Deliveries",
                "Clicks",
                "Sends",
                "Subs",
                "All Drips",
                "All",
            ],

            // fileLoading: false,
            // failure: false,
            // failureMessage: "",

            domain: {},
            loading: false,
            postbackUrl: "",
            showPostbackPopUp: false,

            dialog: false,
            menu: false,
            minDate: moment().subtract(2, "months").format("YYYY-MM-DD"),
            maxDate: moment().format("YYYY-MM-DD"),

            chartLoader: false,
            indexLoader: false,

            selectedChartDataVariant: "",
            selectedDataVariant: "",

            shwThingsToDo: true,
            shwChangeDmnName: false,
            shwConnectPopUp: false,

            failure: false,
            failureMessage: "",
            success: false,
            successMessage: "",

            selectedTimezone: momentTimezone.tz.guess(),
            timezones: momentTimezone.tz.names(),

            refreshModeStatus: false,
            snackbar: false,
            // exportFormat: "select",
            respSubcr: [],
            // groupBySelectValue: "select",
            dmnStatus: null,
            btnClickedTitle: "day",

            welcome: {
                deliveries: {
                    totals: 0,
                    thisWeek: 0,
                },
                clicks: {
                    totals: 0,
                    thisWeek: 0,
                },
                sends: {
                    totals: 0,
                    thisWeek: 0,
                },
            },

            recurring: {
                deliveries: {
                    totals: 0,
                    thisWeek: 0,
                },
                clicks: {
                    totals: 0,
                    thisWeek: 0,
                },
                sends: {
                    totals: 0,
                    thisWeek: 0,
                },
            },

            subs: {
                subs: {
                    totals: 0,
                    thisWeek: 0,
                    thisMonth: 0,
                },
                unsubs: {},
            },
        };
    },
    computed: {
        ...mapGetters([
            "getDomainUrl",
            "roles",
            "permissions",
            "writePermission",
            "readPermission",
        ]),
        ...mapState({
            domains: (state) => state.domain.domains,
        }),
        isUserRole() {
            return this.roles.includes("user");
        },
        isMoreInfoVisible() {
            return (
                this.permissions.includes("stats.domain") &&
                !this.permissions.includes("stats.domain.simple")
            );
        },
        isStatsVisible() {
            return (
                this.permissions.includes("stats.domain") ||
                this.permissions.includes("stats.domain.simple")
            );
        },
        acceptedRole() {
            return this.roles.includes("admin_role") ||
                this.roles.includes("admin_demo") ||
                this.roles.includes("admin") ||
                this.roles.includes("dev") ||
                this.roles.includes("user")
                ? true
                : false;
        },
    },
    mounted() {
        console.log("mounted");
        this.selectedChartDataVariant = this.$refs.apexChart;

        this.chartLoader = true;
        this.indexLoader = true;

        if (this.isUserRole) {
            this.getClientDomains();
        } else {
            this.show();
        }

        //this.triggerInitDomainData();

        //this.checkFileStatus();
    },
    methods: {
        ...mapActions(["logout", "show"]),
        // handleDataVariantUpdated(variant) {
        //   this.selectedDataVariant = variant;
        // },

        async triggerInitDomainData() {
            this.chartLoader = true;
            this.indexLoader = true;

            await this.checkDomainStatus();

            // Get Initial Stats Data
            // Get Totals Subs
            await this.getStatisticBySubs(
                null,
                null,
                this.$route.params.id,
                3600,
                ""
            );
            await this.getStatisticBySubsForMonth(this.$route.params.id, 3600);
            await this.getTotalStatisticByDrips();
            await this.getInitialStats();

            queueMicrotask(() => {
                setTimeout(() => {
                    this.chartLoader = false;
                    this.indexLoader = false;
                }, 1500);
            });
        },
        addPostback() {
            if (!this.postbackUrl) {
                this.failureMessage = "Type your postback url!";
                this.failure = true;

                return false;
            }

            this.loading = true;

            Domains.update(this.$route.params.id, {
                fcm_conf: "client",
                postback: this.postbackUrl,
            })
                .then((response) => {
                    console.log("🚀 ~ .then ~ response:", response);
                    this.show();

                    this.domain = response.data.data;
                    this.postbackUrl = response.data.data.postback;
                    this.showPostbackPopUp = false;

                    this.successMessage =
                        "Domain postback has been updated successfully!";
                    this.success = true;
                })
                .catch((error) => {
                    this.failureMessage = error;
                    this.failure = true;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getClientDomains() {
            return new Promise((resolve, reject) => {
                Domains.getClientDomains()
                    .then((response) => {
                        resolve(response);

                        this.$store.state.domain.domains = response.data.data;
                    })
                    .catch((error) => {
                        reject(error);

                        this.failureMessage = error;
                        this.failure = true;
                    });
            });
        },
        async refreshChart() {
            this.refreshModeStatus = true;

            this.dateRange = "day";
            this.selectedTimezone = momentTimezone.tz.guess();
            this.datePicker = [
                moment().subtract(1, "weeks").format("YYYY-MM-DD"),
                moment().format("YYYY-MM-DD"),
            ];

            this.resetSeries();

            this.getInitialStats();

            queueMicrotask(() => {
                setTimeout(() => {
                    this.refreshModeStatus = false;
                }, 1500);
            });
        },
        setChartRange(event) {
            if (event.target.id !== "exportAsFormat") {
                this.btnClickedTitle = event.target.innerText;
            }
        },
        checkDomainStatus() {
            Domains.show(`/${this.$route.params.id}`).then((response) => {
                this.domain = response.data.data[0];
                this.dmnStatus = response.data.data[0].is_active;
                this.postbackUrl = response.data.data[0].postback;

                this.dmnStatus
                    ? document
                          .querySelectorAll("em.bi[class^='bi bi-toggle-']")[0]
                          .classList.add("bi-toggle-on")
                    : document
                          .querySelectorAll("em.bi[class^='bi bi-toggle-']")[0]
                          .classList.add("bi-toggle-off");
            });
        },
        getTotalStatisticByDrips() {
            let headers = {
                "Content-Type": "application/json",
                Accept: "application/json",
                resultGroupBy: "type:recurring,welcome",
                withFormulas: false,
                cache: 3600,
            };

            return new Promise((resolve, reject) => {
                Statistics.getStatsEventsByDrips(
                    `domain_ids=${this.$route.params.id}&timezone=${this.selectedTimezone}&default_group_by=false&group_by=type`,
                    headers
                )
                    .then((response) => {
                        resolve(response);

                        for (let type of ["recurring", "welcome"]) {
                            this[type]["deliveries"]["totals"] =
                                response.data.data[type][0].delivered;
                            this[type]["clicks"]["totals"] =
                                response.data.data[type][0].clicked;
                            this[type]["sends"]["totals"] =
                                response.data.data[type][0].sent;
                        }
                    })
                    .catch((err) => {
                        reject(err);

                        if (
                            err.response.status === 419 ||
                            err.response.status === 401
                        ) {
                            this.logout().then(() => {
                                localStorage.removeItem("auth");
                                //localStorage.removeItem("login");
                                this.$route.replace({
                                    name: "Login",
                                    path: this.$route.path,
                                });
                            });
                        } else {
                            console.error(err, "err 1");
                            this.error = err;
                        }
                    });
            });
        },
        // Get Subs For Month
        getStatisticBySubsForMonth(domainId, cache) {
            let dateStart = moment().subtract(1, "months").format("YYYY-MM-DD");
            let dateEnd = moment().format("YYYY-MM-DD");

            Statistics.getStatsBySubscribables(
                `domain_ids=${domainId}&date_start=${dateStart}&date_finish=${dateEnd}&date_trunc=month&timezone=${this.selectedTimezone}`,
                {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    cache: cache,
                }
            ).then((response) => {
                this.subs["subs"]["thisMonth"] = this.getSum(
                    response.data.data,
                    "subscribed"
                );
            });
        },
        getStatsPushErrors(dateStart = null, dateEnd = null, cache, date) {
            let dateTruncParams = date ? `date_trunc=${date}&` : "";
            let dateParams = dateStart
                ? `date_start=${dateStart}&date_finish=${dateEnd}`
                : "";
            let headers =
                this.isModerRole && this.selectedClient
                    ? {
                          "Content-Type": "application/json",
                          Accept: "application/json",
                          resultGroupBy: "type:recurring,welcome",
                          withFormulas: "false",
                          cache: cache,
                          client: this.selectedClient,
                      }
                    : {
                          "Content-Type": "application/json",
                          Accept: "application/json",
                          resultGroupBy: "type:recurring,welcome",
                          withFormulas: "false",
                          cache: cache,
                      };

            return new Promise((resolve, reject) => {
                Statistics.getStatsPushErrors(
                    dateTruncParams +
                        dateParams +
                        `&timezone=${this.selectedTimezone}&domain_ids=${this.$route.params.id}`,
                    headers
                )
                    .then((response) => {
                        resolve(response);

                        if (
                            Array.isArray(response.data.data) &&
                            !response.data.data.length
                        ) {
                            throw new Error("Invalid response");
                        }

                        this.subsSeries.push(
                            this.modifyDataForCreatingCharts(
                                response.data.data ?? 0,
                                "error_401",
                                "Error 401",
                                this.btnClickedTitle === "hour"
                            )
                        );
                        this.subsSeries.push(
                            this.modifyDataForCreatingCharts(
                                response.data.data ?? 0,
                                "error_403",
                                "Error 403",
                                this.btnClickedTitle === "hour"
                            )
                        );
                        this.subsSeries.push(
                            this.modifyDataForCreatingCharts(
                                response.data.data ?? 0,
                                "error_404",
                                "Error 404",
                                this.btnClickedTitle === "hour"
                            )
                        );
                        this.subsSeries.push(
                            this.modifyDataForCreatingCharts(
                                response.data.data ?? 0,
                                "error_413",
                                "Error 413",
                                this.btnClickedTitle === "hour"
                            )
                        );
                        this.subsSeries.push(
                            this.modifyDataForCreatingCharts(
                                response.data.data ?? 0,
                                "error_429",
                                "Error 429",
                                this.btnClickedTitle === "hour"
                            )
                        );
                        this.subsSeries.push(
                            this.modifyDataForCreatingCharts(
                                response.data.data ?? 0,
                                "error_x",
                                "Error X",
                                this.btnClickedTitle === "hour"
                            )
                        );
                    })
                    .catch((err) => {
                        reject(err);

                        if (
                            err.response !== undefined &&
                            (err.response.status === 419 ||
                                err.response.status === 401)
                        ) {
                            this.logout().then(() => {
                                localStorage.removeItem("auth");
                                this.$route.replace({
                                    name: "Login",
                                    path: this.$route.path,
                                });
                            });
                        } else {
                            this.error = err;
                        }
                    });
            });
        },
        // Get subs
        getStatisticBySubs(dateStart = null, dateEnd = null, dmn, cache, date) {
            let dateTruncParams = date ? `&date_trunc=${date}` : "";
            let dateParams = dateStart
                ? `&date_start=${dateStart}&date_finish=${dateEnd}`
                : "";

            return new Promise((resolve, reject) => {
                Statistics.getStatsBySubscribables(
                    `domain_ids=${dmn}` +
                        dateTruncParams +
                        dateParams +
                        `&timezone=${this.selectedTimezone}`,
                    {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                        cache: cache,
                    }
                )
                    .then((response) => {
                        // Data For The Line Chart
                        if (dateParams && dateTruncParams) {
                            this.respSubcr = [];
                            this.respSubcr = response.data.data;

                            this.subsDataForExportFile = response.data.data;

                            this.subsSeries[0] =
                                this.modifyDataForCreatingCharts(
                                    response?.data?.data || [],
                                    "full_unsubscribed",
                                    "Full Unsubscribed",
                                    this.btnClickedTitle === "hour"
                                );

                            this.subsSeries[1] =
                                this.modifyDataForCreatingCharts(
                                    response?.data?.data || [],
                                    "deactivated",
                                    "Deactivated",
                                    this.btnClickedTitle === "hour"
                                );

                            this.subsSeries[2] =
                                this.modifyDataForCreatingCharts(
                                    response?.data?.data || [],
                                    "unsubscribed",
                                    "Unsubscribed",
                                    this.btnClickedTitle === "hour"
                                );

                            this.subsSeries[3] =
                                this.modifyDataForCreatingCharts(
                                    response?.data?.data || [],
                                    "subscribed",
                                    "Subscribed",
                                    this.btnClickedTitle === "hour"
                                );
                        }

                        // Data For Totals
                        if (dateStart === null) {
                            this.subs.subs.totals = this.getSum(
                                response?.data?.data || [],
                                "subscribed"
                            );
                        }

                        // Data For ThisWeek
                        if (
                            dateStart ===
                                moment()
                                    .subtract(1, "weeks")
                                    .format("YYYY-MM-DD") &&
                            dateEnd === moment().format("YYYY-MM-DD") &&
                            date
                        ) {
                            this.subs["subs"]["thisWeek"] = this.getSum(
                                response?.data?.data || [],
                                "subscribed"
                            );
                        }

                        resolve(response);
                    })
                    .catch((err) => {
                        reject(err);

                        if (
                            err.response !== undefined &&
                            (err.response.status === 419 ||
                                err.response.status === 401)
                        ) {
                            this.logout().then(() => {
                                localStorage.removeItem("auth");
                                //localStorage.removeItem("login");
                                this.$route.replace({
                                    name: "Login",
                                    path: this.$route.path,
                                });
                            });
                        } else {
                            console.error(err, "err 4");
                            this.error = err;
                        }
                    });
            });
        },
        getStatisticByDrips(
            dateStart = null,
            dateEnd = null,
            dmnId,
            cache,
            date
        ) {
            let dateTruncParams = date ? `date_trunc=${date}&` : "";
            //let dripIdParams = dripId ? `&group_by=drip_id` : "";
            // let dripTypeParams = type
            //   ? `drip_type=${type}&default_group_by=false`
            //   : "";
            let dateParams = dateStart
                ? `date_start=${dateStart}&date_finish=${dateEnd}`
                : "";
            let headers = {
                "Content-Type": "application/json",
                Accept: "application/json",
                resultGroupBy: "type:recurring,welcome",
                withFormulas: false,
                cache: cache,
            };

            return new Promise((resolve, reject) => {
                Statistics.getStatsEventsByDrips(
                    `domain_ids=${dmnId}&` +
                        dateTruncParams +
                        dateParams +
                        // dripTypeParams +
                        `&timezone=${this.selectedTimezone}&default_group_by=false&group_by=type`,
                    //)
                    //dripIdParams,
                    headers
                )
                    .then((response) => {
                        resolve(response);

                        // Data For The Line Chart
                        if (dateParams && dateTruncParams) {
                            for (let [i, type] of [
                                "recurring",
                                "welcome",
                            ].entries()) {
                                console.log(type, i);

                                this.sendsSeries[i] =
                                    this.modifyDataForCreatingCharts(
                                        response.data.data[type] || [],
                                        "sent",
                                        "Sent " + type,
                                        this.btnClickedTitle === "hour"
                                    );

                                this.clicksSeries[i] =
                                    this.modifyDataForCreatingCharts(
                                        response.data.data[type] || [],
                                        "clicked",
                                        "Clicked " + type,
                                        this.btnClickedTitle === "hour"
                                    );

                                this.deliveriesSeries[i] =
                                    this.modifyDataForCreatingCharts(
                                        response.data.data[type] || [],
                                        "delivered",
                                        "Delivered " + type,
                                        this.btnClickedTitle === "hour"
                                    );

                                // Data For This Week
                                if (
                                    dateStart ===
                                        moment()
                                            .subtract(1, "weeks")
                                            .format("YYYY-MM-DD") &&
                                    dateEnd === moment().format("YYYY-MM-DD") &&
                                    type
                                ) {
                                    this[type]["deliveries"]["thisWeek"] =
                                        this.getSum(
                                            response.data.data[type] || [],
                                            "delivered"
                                        );
                                    this[type]["clicks"]["thisWeek"] =
                                        this.getSum(
                                            response.data.data[type] || [],
                                            "clicked"
                                        );
                                    this[type]["sends"]["thisWeek"] =
                                        this.getSum(
                                            response.data.data[type] || [],
                                            "sent"
                                        );
                                }
                            }
                        }
                    })
                    .catch((err) => {
                        reject(err);

                        if (
                            err.response !== undefined &&
                            (err.response.status === 419 ||
                                err.response.status === 401)
                        ) {
                            this.logout().then(() => {
                                localStorage.removeItem("auth");
                                //localStorage.removeItem("login");
                                this.$route.replace({
                                    name: "Login",
                                    path: this.$route.path,
                                });
                            });
                        } else {
                            console.error(err, "err 3");
                            this.error = err;
                        }
                    });
            });
        },
        // Change Domain Status
        changeDmnStatus() {
            this.$swal
                .fire({
                    title: "Are you sure?",
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonColor: "#007bff",
                    cancelButtonColor: "#F8F9FA",
                    cancelButtonColorText: "#000",
                    confirmButtonText: "Yes!",
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        Domains.update(this.$route.params.id, {
                            fcm_conf: "client",
                            is_active: this.dmnStatus ? 0 : 1,
                        })
                            .then((response) => {
                                this.show();

                                this.dmnStatus = response.data.data.is_active;
                                this.dmnStatus
                                    ? document
                                          .querySelectorAll(".bi")[3]
                                          .classList.add("bi-toggle-on")
                                    : document
                                          .querySelectorAll(".bi")[3]
                                          .classList.add("bi-toggle-off");

                                this.successMessage =
                                    "Domain status has been updated successfully!";
                                this.success = true;
                            })
                            .catch((error) => {
                                this.failureMessage = error;
                                this.failure = true;
                            });
                    }
                });
        },
        // Get & Download Sw File
        generateDomainFiles(event) {
            let websiteId = this.selectedDomainWebsite(
                this.$route.params.id
            ).website_id;
            let fileName = "";

            if (event.target.innerText.includes("sw")) {
                fileName = "sw_pm";
            } else if (event.target.innerText.includes("pushmine")) {
                fileName = "pushmine";
            }

            // Send Request To Get File
            Domains.getDomainFile({ filename: fileName, website_id: websiteId })
                .then((response) => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", fileName + ".js");
                    document.body.appendChild(link);
                    link.click();
                    // Delete Link From Body
                    setTimeout(() => {
                        document
                            .querySelector(`a[download=${fileName + ".js"}]`)
                            .remove();
                    }, 1000);
                })
                .catch((err) => {
                    this.error = err;
                    console.error(err, "err 2");
                });
        },
        copy() {
            let span = document.createElement("span");
            let el = document.createElement("textarea");
            let elVal = document.querySelector("pre").innerHTML;

            elVal = elVal.replace(
                /&[#A-Za-z0-9]+;/gi,
                (entity, position, text) => {
                    span.innerHTML = entity;
                    return span.innerText;
                }
            );

            el.value = elVal;

            el.setAttribute("readonly", "");
            el.style.position = "absolute";
            el.style.left = "-9999px";
            document.createElement("textarea");
            document.body.appendChild(el);
            el.select();
            document.execCommand("copy");
            this.snackbar = true;
            document.body.removeChild(el);
        },
        resetSeries() {
            this.sendsSeries = [];
            this.clicksSeries = [];
            this.deliveriesSeries = [];
            this.totalsSeries = [];
            this.subsSeries = [];
            this.unsubsSeries = [];
        },
        resetValues() {
            for (let obj of ["recurring", "welcome", "subs"])
                for (let key of Object.keys(obj)) {
                    if (key !== "unsubs") {
                        this[obj][key] = 0;
                    }
                }
        },
        async getInitialStats() {
            // this.chartLoader = true;
            // this.indexLoader = true;

            await this.getStatisticByDrips(
                moment(this.datePicker[0]).format("YYYY-MM-DD"),
                moment(this.datePicker[1]).format("YYYY-MM-DD"),
                this.$route.params.id,
                3600,
                this.btnClickedTitle
            );
            // for (let type of ["recurring", "welcome", ""]) {
            //   // For The Line Chart
            //   this.getStatisticByDrips(
            //     moment(this.datePicker[0]).format("YYYY-MM-DD"),
            //     moment(this.datePicker[1]).format("YYYY-MM-DD"),
            //     this.$route.params.id,
            //     3600,
            //     this.btnClickedTitle,
            //     //type
            //   );

            //   await this.getStatisticByDrips(
            //     null,
            //     null,
            //     this.$route.params.id,
            //     3600,
            //     "",
            //     //type
            //   );
            // }

            // Get Subs For The Line Chart & ThisWeek
            await this.getStatisticBySubs(
                moment(this.datePicker[0]).format("YYYY-MM-DD"),
                moment(this.datePicker[1]).format("YYYY-MM-DD"),
                this.$route.params.id,
                3600,
                this.btnClickedTitle
            );

            // // Get Totals Subs
            // await this.getStatisticBySubs(
            //   null,
            //   null,
            //   this.$route.params.id,
            //   3600,
            //   ""
            // );

            // Get Subs For ThisMonth
            //await this.getStatisticBySubsForMonth(this.$route.params.id, 3600);

            // queueMicrotask(() => {
            //   this.chartLoader = false;
            //   this.indexLoader = false;
            // });
        },
        async getDataForChart() {
            this.chartLoader = true;

            await this.getStatisticByDrips(
                moment(this.datePicker[0]).format("YYYY-MM-DD"),
                moment(this.datePicker[1]).format("YYYY-MM-DD"),
                this.$route.params.id,
                3600,
                this.btnClickedTitle
            );
            // Get Drips
            // for (let type of ["recurring", "welcome", ""]) {
            //   // For The Line Chart
            //   await this.getStatisticByDrips(
            //     moment(this.datePicker[0]).format("YYYY-MM-DD"),
            //     moment(this.datePicker[1]).format("YYYY-MM-DD"),
            //     this.$route.params.id,
            //     3600,
            //     this.btnClickedTitle,
            //     //type
            //   );
            // }

            // Get Subs For The Line Chart & ThisWeek
            await this.getStatisticBySubs(
                moment(this.datePicker[0]).format("YYYY-MM-DD"),
                moment(this.datePicker[1]).format("YYYY-MM-DD"),
                this.$route.params.id,
                3600,
                this.btnClickedTitle
            );

            if (this.selectedDataVariant === "Subs") {
                await this.getStatsPushErrors(
                    moment(this.datePicker[0]).format("YYYY-MM-DD"),
                    moment(this.datePicker[1]).format("YYYY-MM-DD"),
                    3600,
                    this.btnClickedTitle
                );
            }

            queueMicrotask(() => {
                this.chartLoader = false;
            });
        },
    },
    watch: {
        "$route.params.id": {
            handler() {
                console.log("Watching route.params.id");
                this.resetSeries();

                this.triggerInitDomainData();

                this.exportFormat = "select";
            },
            deep: true,
            immediate: true,
        },
        selectedDataVariant(type) {
            if (type === "Subs") {
                this.chartLoader = true;

                this.getStatsPushErrors(
                    moment(this.datePicker[0]).format("YYYY-MM-DD"),
                    moment(this.datePicker[1]).format("YYYY-MM-DD"),
                    3600,
                    this.btnClickedTitle
                ).finally(() => {
                    this.chartLoader = false;
                });
            }
        },
        btnClickedTitle(dateRange, prevDateRange) {
            if (prevDateRange && prevDateRange !== dateRange) {
                this.resetValues();
                this.resetSeries();

                this.getDataForChart();
            }
        },
        selectedTimezone() {
            this.resetSeries();

            this.getDataForChart();

            this.exportFormat = "select";
        },
        datePicker(value) {
            if (value.length === 1) {
                return false;
            }

            this.resetSeries();

            this.getDataForChart();

            this.exportFormat = "select";
        },
    },
};
</script>

<style scoped>
.index-block {
    height: 20px;
    display: flex;
    justify-content: center;
}
.index-overflow {
    overflow-x: auto;
    width: 75px;
}
::-webkit-scrollbar {
    display: none;
}
.font-size-11 {
    font-size: 11px !important;
}
select#exportAsFormat,
select#groupBySelectValue {
    background: #fff !important;
    color: #686868;
    font-size: 11px;
    border: 1px solid #68686852;
}
.box.bg-2 {
    background-color: unset !important;
}
.sub-card {
    max-width: 300px;
}
.swal2-cancel {
    color: rgb(77, 77, 77) !important;
}
.container .row:nth-child(2) div + div {
    padding-right: 3px;
}
.container .row.d-flex div.col-md-2,
.container .row.d-flex div.col-md-3 {
    border: 1px solid #dfe1e5;
    position: relative;
    height: 170px;
}
.container .row:nth-child(2) div span svg {
    margin-right: 5px;
}
.container .row:nth-child(2) div span:nth-child(1),
.container .row:nth-child(2) div span:nth-child(2),
.container .row:nth-child(2) div span:nth-child(3),
.more-info-block {
    display: flex;
}
.container .row:nth-child(2) div span:nth-child(1) {
    font-size: 11px;
}
.container .row:nth-child(2) div span:nth-child(2) {
    font-weight: 700;
    font-size: 24px;
}
.small-text {
    font-size: 14px;
    color: #272727;
}
.more-info-block {
    justify-content: space-between;
    align-items: center;
    position: absolute;
    bottom: 0;
    /* left: 13px; */
    width: 100%;
    left: 0;
    padding: 12px 12px 12px;
    font-size: 11px;
    background: #ebebec;
}
.col-md-2 {
    flex: 0 0 15.666667% !important;
}

.btn-group {
    margin: 12px 0 0 0;
    width: 206px;
    height: 31px;
}

.chart-btn {
    width: 63px;
    height: 31px;
    padding: 9px 20px;
    border: 1px solid #bdbdbd;
    border-radius: 4px;
    font-weight: 500;
    font-size: 9px;
    color: #7f7f7f !important;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 12px 0 0;
}

.chart-btn-active {
    border: 1px solid #3579f5;
    background: #3579f5 !important;
    color: #fff !important;
    box-shadow: 0px 2px 2px 0px #a3a3a3;
}

.chart-btn.chart-btn-active:hover {
    background: #2b66d3 !important;
}

.chart-btn:not(.chart-btn.chart-btn-active):hover {
    border: 1px solid #949494;
    color: #686767 !important;
}

.v-input__slot {
    width: 71px !important;
    font-size: 14px !important;
}

.v-text-field > .v-input__control > .v-input__slot:before {
    border: unset !important;
}

.v-icon.notranslate.mdi.mdi-calendar.theme--light {
    font-size: 15px !important;
}

@media (max-width: 768px) {
    .navbar-nav.ml-auto {
        overflow-x: scroll;
    }
    .lst-notif-block {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .mt-mb-style {
        margin-top: 3rem !important;
    }
    .mb-font-size {
        font-size: 12px !important;
    }
}
</style>
